export class AnalyticsTracker {
  /**
   * @returns {Object|undefined} The PayPal analytics instance or undefined if not available.
   */
  get instance() {
    return window.PAYPAL?.analytics?.instance
  }

  /**
   * @returns {boolean} True if the analytics instance is available, false otherwise.
   */
  get isInstanceAvailable() {
    return Boolean(this.instance)
  }

  /**
   * @param {Object} event - The event object to be clean from the context
   * @returns {void}
   */
  _cleanContext(event) {
    Object.keys(event).forEach((key) => {
      window.fpti[key] = null
    })
  }

  /**
   * @param {Object} event - The event object to record.
   * @returns {void}
   */
  recordClick(event) {
    if (this.isInstanceAvailable) {
      this.instance.recordClick({ data: event })
      this._cleanContext(event)
    }
  }

  /**
   * @param {Object} event - The event object to record.
   * @returns {void}
   */
  recordImpression(event) {
    if (this.isInstanceAvailable) {
      this.instance.recordImpression({ data: event })
      this._cleanContext(event)
    }
  }
}
